const routes = [
  {
    index: true,
    label: 'Georgi Karapetrov',
    path: '/',
  },
  {
    label: 'About',
    path: '/about',
  },
  {
    label: 'Resume',
    path: '/resume',
  },
  /*
  {
    label: 'Projects',
    path: '/projects',
  },
  */
  {
    label: 'Stats',
    path: '/stats',
  },
  {
    label: 'Contact',
    path: '/contact',
  },
  {
    label: 'Donate',
    path: '/donate',
  },
];

export default routes;
